module.exports = __webpack_public_path__ + "static/media/nextGreyArrow.4aabb21f.svg";